import { THEMES } from '../../configs/LayoutConfig';

const ChartConfig = {
  Dark: {
    backgroundColor: '#282828',
    vertGridProperties: '#1F2329',
    horzGridProperties: '#1F2329',
  },
  Light: {
    backgroundColor: '#ffffff',
    vertGridProperties: '#ffffff',
    horzGridProperties: '#ffffff',
  },
  Classic: {
    backgroundColor: '#1F2329',
    vertGridProperties: '#1F2329',
    horzGridProperties: '#1F2329',
  },
};

export const getOverrides = theme => {
  return {
    'mainSeriesProperties.candleStyle.upColor': '#379448',
    'mainSeriesProperties.candleStyle.borderUpColor': '#026E30',
    'mainSeriesProperties.candleStyle.downColor': '#BB0001',
    'mainSeriesProperties.candleStyle.borderDownColor': '#9A0000',
    'mainSeriesProperties.barStyle.upColor': '#379448',
    'mainSeriesProperties.barStyle.downColor': '#BB0001',
    'paneProperties.background': ChartConfig[theme].backgroundColor,
    'paneProperties.vertGridProperties.color':
      ChartConfig[theme].vertGridProperties,
    'paneProperties.horzGridProperties.color':
      ChartConfig[theme].horzGridProperties,
  };
};

export const commonConfig = {
  autosize: true,
  timezone: 'Asia/Bangkok',
  debug: false,
  enabled_features: ['countdown'],
  studies_overrides: {
    'volume.volume.color.0': '#BB0001',
    'volume.volume.color.1': '#379448',
    'volume.show ma': true,
    'volume.volume ma.color': 'rgba(255,156,87, 0)',
  },
  disabled_features: [
    'header_saveload',
    'header_screenshot',
    'header_fullscreen_button',
    'use_localstorage_for_settings',
    'display_market_status',
    'symbol_search_hot_key',
    'show_dialog_on_snapshot_ready',
  ],
  time_frames: [
    { text: '1d', resolution: '1', title: '1D' },
    { text: '5d', resolution: '5', title: '5D' },
    { text: '1m', resolution: 'D', title: '1M' },
    { text: '3m', resolution: 'D', title: '3M' },
    { text: '1y', resolution: 'D', title: '1Y' },
    { text: '5y', resolution: 'W', title: '5Y' },
  ],
  custom_css_url: '/charting_library/style.css',
};
